import { css, jsx } from '@emotion/core';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import HeroContent from '@/src/cms/components/CMSPage/CorePage/HeroContent';
import DesignPage from '@/src/cms/models/DesignPage';
import ChartProfiles from '@/src/profile/ChartProfiles';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const style = {
  section: css`
    padding-top: 0px !important;
  `,
  anchor: css`
    color: #003da6;
    font-weight: 900;
    margin-top: 14px;
    display: inline-block;
  `,
};

const MemberRelationsTeam = props => {
  const router = useRouter();

  const { messageData = {} } = props;
  const { route } = router;

  const [profileData, setProfileData] = useState({});
  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);
  const enableBio = false;

  const fetchPageData = async () => {
    const pageResponse = await request({
      url: `cms/designpage`,
      params: {
        alias: 'member-relations-team',
      },
    });
    const response = await request({
      url: `profile/chartprofiles`,
      method: 'GET',
      params: {
        chartid: 6,
      },
    });
    setPageData(pageResponse.data);
    setProfileData(response.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchPageData();
  }, []);

  if (loading) {
    return null;
  }

  const { Profiles } = profileData;
  const page = new DesignPage({ ...pagedata, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="391" pageType="content" />
      <HeroContent heroData={page}>
        <a
          href="mailto:membership@apci.org"
          css={style.anchor}
        >
          E-mail Member Relations Team
        </a>
      </HeroContent>
      <Section css={style.section}>
        <Container>
          <ChartProfiles profiles={Profiles} route={route} enableBio={enableBio} />
        </Container>
      </Section>
      <WebLogImage path="/about/membership/member-relations-team" pagedata={pagedata} />
    </Layout>
  );
};

export default MemberRelationsTeam;
